// @flow
import React from 'react';
import { Creatable } from 'react-select';
import { customStyles, customTheme, SelectLayout } from './selectStyles';
import NotificationMessage from '../NotificationMessage';

type SelectCreatableProps = {
  errorText?: ?string,
  iconDecoration?: ?string,
  isClearable?: boolean,
  isDisabled?: boolean,
  isLoading?: boolean,
  isSearchable?: boolean,
  loadingMessage?: () => string,
  placeholder: ?string,
  size: string,
};

const SelectCreatable = ({ size, iconDecoration, errorText, ...props }: SelectCreatableProps) => (
  <SelectLayout>
    <Creatable
      {...props}
      styles={customStyles(iconDecoration, size, errorText)}
      theme={customTheme(size)}
    />
    {errorText && <NotificationMessage styleType="error">{errorText}</NotificationMessage>}
  </SelectLayout>
);

export default SelectCreatable;

SelectCreatable.defaultProps = {
  errorText: undefined,
  iconDecoration: undefined,
  isClearable: false,
  isDisabled: false,
  isLoading: false,
  isSearchable: true,
  loadingMessage: () => 'Loading...',
  placeholder: 'Select...',
  size: 'medium',
};
